module.exports = __webpack_public_path__ + "img/tpc-web-11.4dbb8fbb.webp";